import React, { Component } from "react";
import '../assets/templates/IrregularVerbs.css';
import LessonInstruction from "../containers/instruction/LessonInstruction";

class IrregularVerbs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      index: 0,
      divPositions: []
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.contentIndex !== this.props.contentIndex){
      this.setState({
        open: false,
      })
    }
  }

  _reset(){
    this.setState({
      open: false
    })
  }

  render() {
    const { blockData, contentIndex, audioUrl } = this.props;

    // temporary - sets background to white color
    const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
    const containerClasses = `default-card ${bgColor}`;

    return (
      <div className={containerClasses}>
        <div style={{width: '90%'}}>
            {
                blockData.content[contentIndex].type === 'instruction' ?
                <>
                  <LessonInstruction
                    instructionText={blockData.content[contentIndex].instruction}
                    audioUrl={audioUrl}
                  />
                </>
                :
                <div style={{width: '100%'}}>   
                    {
                        blockData.content.filter((x) => { return x.type !== "instruction"}).map((item, index)=>{
                            return(
                                <div 
                                ref={(ref)=>{
                                    // scroll to the current div position
                                    if(ref && item.id === blockData.content[contentIndex].id){ window.scrollTo(0, ref.offsetTop - (window.innerHeight / 2)) }
                                }}
                                key={index} className={"irregular-verbs-container " + (item.id === blockData.content[contentIndex].id ? "simple-active" : "")} >
                                    {
                                        item.en.split(',').map((verb, verbIndex) => {
                                            return(
                                                <h2 key={verbIndex} style={{color: "white"}}>
                                                    { verb } 
                                                </h2> 
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                
            }
        </div>
      </div>
    )
  }
}

export default IrregularVerbs
